import React, { FunctionComponent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretRight,
  faChevronCircleDown,
  faChevronCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Collapse } from "react-bootstrap";

type OwnProps = {
  openByParentControl?: boolean;
  setOpenByParentControl?: React.Dispatch<React.SetStateAction<boolean>>;
  useChevronIcons?: boolean;
  header?: React.ReactNode;
  label?: string;
  className?: string;
  children?: React.ReactNode;
};

type Props = OwnProps;

const CollapsedContainer: FunctionComponent<Props> = (props) => {
  const {
    header,
    useChevronIcons,
    className,
    label,
    children,
    openByParentControl,
    setOpenByParentControl,
  } = props;
  const [selfCollapsed, setSelfCollapsed] = useState(true);

  const handleContainerCollapse = () => {
    if (setOpenByParentControl) {
      setOpenByParentControl((collapsed) => !collapsed);
    } else {
      setSelfCollapsed((collapsed) => !collapsed);
    }
  };

  const collapsed = setOpenByParentControl
    ? openByParentControl
    : selfCollapsed;

  return (
    <div className={className ?? "exampleCollapseContainer my-3"}>
      <div
        className="d-flex align-items-center"
        aria-controls="common-collapse"
        aria-expanded={collapsed}
      >
        <div className="mr-3" onClick={handleContainerCollapse}>
          <FontAwesomeIcon
            size={"2x"}
            icon={
              collapsed
                ? useChevronIcons
                  ? faChevronCircleDown
                  : faCaretDown
                : useChevronIcons
                ? faChevronCircleRight
                : faCaretRight
            }
          />
        </div>
        {header ?? <h3 className="font-weight-bold mb-0">{label}</h3>}
      </div>
      <Collapse in={collapsed}>
        <div id="common-collapse">{children}</div>
      </Collapse>
    </div>
  );
};

export default CollapsedContainer;
